import { render, staticRenderFns } from "./column-edit.vue?vue&type=template&id=40f6990a&scoped=true&"
import script from "./column-edit.vue?vue&type=script&lang=js&"
export * from "./column-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f6990a",
  null
  
)

export default component.exports